module.exports = __webpack_public_path__ + "static/media/image15.e0df2cd3.png";